import CargoCompanyAddressUpdateRequest, {
  CargoCompanyAddressUpdateRequestBody,
} from "./cargo-company-address-update.request";

const create = (
  request: CargoCompanyAddressUpdateRequest,
): CargoCompanyAddressUpdateRequestBody => {
  return {
    apartment: request.apartment,
    country: request.country,
    description: request.description,
    houseNo: request.houseNo,
    lat: request.lat,
    lon: request.lon,
    street: request.street,
    town: request.town,
    type: request.type,
    zipCode: request.zipCode,
  };
};

const cargoCompanyAddressUpdateRequestFactory = {
  create,
};

export default cargoCompanyAddressUpdateRequestFactory;
